// src/components/AboutUs.js

import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import styles from "../style/AboutUs.module.css";

const AboutUs = () => {
  const { t } = useTranslation();

  const creedRef = useRef(null);
  const manifestoRef = useRef(null);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h2 className={styles.subtitle}>{t("About McKnight Homme")}</h2>

        <nav className={styles.nav}>
          <span
            className={styles.navItem}
            onClick={() =>
              creedRef.current?.scrollIntoView({ behavior: "smooth" })
            }
          >
            {t("The McKnight Creed")}
          </span>
          <span
            className={styles.navItem}
            onClick={() =>
              manifestoRef.current?.scrollIntoView({ behavior: "smooth" })
            }
          >
            {t("The McKnight Manifesto")}
          </span>
        </nav>
      </header>

      {/* The McKnight Creed */}
      <section id="mcknight-creed" className={styles.section} ref={creedRef}>
        <div className={styles.textOnlyContainer}>
          <h3 className={styles.sectionTitle}>{t("The McKnight Creed")}</h3>

          <p className={styles.sectionText}>
            <strong>{t("The clothes are the medium.")}</strong>
            <br />
            {t(
              "Each garment is a vessel — tailored with discipline, precision, and reverence for form."
            )}
            <br />
            {t("Through it, we express not mere elegance, but intention.")}
          </p>

          <p className={styles.sectionText}>
            <strong>
              {t("The message is aspire and travail for a higher life.")}
            </strong>
            <br />
            {t("To be a man is to strive.")}
            <br />
            {t("To build, to fail, to rise again.")}
            <br />
            {t(
              "We believe in the labor of self — in walking with composure through the furnace that refines character."
            )}
          </p>

          <p className={styles.sectionText}>
            <strong>{t("The goal is to drive men forward.")}</strong>
            <br />
            {t("Forward in purpose.")}
            <br />
            {t("Forward in strength.")}
            <br />
            {t("Forward into the man they are called to become.")}
          </p>

          <p className={styles.sectionText}>
            <strong>{t("This is McKnight.")}</strong>
            <br />
            {t(
              "Clothing for the man who remembers that greatness begins within."
            )}
          </p>
        </div>
      </section>
      <section
        id="mcknight-manifesto"
        className={styles.section}
        ref={manifestoRef}
      >
        <div className={styles.textOnlyContainer}>
          <h3 className={styles.sectionTitle}>{t("The McKnight Manifesto")}</h3>
          <p className={styles.sectionText}>
            {t(
              "McKnight is more than fashion. It is philosophy in cloth. Every creation is a declaration of order, discipline, and composure. Each man who wears it, carries the emblem of mastery — over his craft, his impulses, his life. We believe a man’s appearance should reflect the excellence within. Our purpose is not to dress men, but to awaken them — to the strength of restraint, the nobility of composure, and the quiet pride of self-command. McKnight exists for the men who build. Who rise. Who carry themselves with intention. For them, elegance is not excess — it is control. McKnight is not a brand. It is a standard. A reminder that every man can become more — if he dares to travail for a higher life."
            )}
          </p>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
